module.exports = __webpack_public_path__ + "img/element-heading.9467ccb.svg";